import React from "react";
import MaskedInput from "react-text-mask";

type Props = {
  inputRef: (ref: HTMLInputElement | null) => void;
};

const PhoneNumberWrapper = ({ inputRef, ...other }: Props) => {
  return (
    <MaskedInput
      {...other}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "(",
        /[1-9]/,
        /\d/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={"\u2000"}
      showMask={false}
    />
  );
};

export default PhoneNumberWrapper;
